import { Star, Quote } from "lucide-react";
import Reveal from "@/components/Reveal";

const quotes = [
  {
    name: "Marcus T.",
    city: "Boise, ID",
    tag: "9,000-card MTG collection",
    text: "Inherited my brother's Magic binders and had no idea where to start. The offer came with a full breakdown — I spot-checked three cards against sold listings and the numbers were honest.",
  },
  {
    name: "Danielle R.",
    city: "Tampa, FL",
    tag: "Graded Pokémon slabs",
    text: "Shipped forty slabs on their insured label, and the money hit my account the day after delivery. Easiest sale I've ever made, start to finish.",
  },
  {
    name: "The Nguyen Family",
    city: "Sacramento, CA",
    tag: "Sealed booster cases",
    text: "We quoted three buyers. The Vault wasn't just the highest — they were the only ones who actually explained the math behind the number.",
  },
  {
    name: "Chris P.",
    city: "Austin, TX",
    tag: "Mixed vintage hoard",
    text: "Local to Texas and met the aardvark energy firsthand. Fair price, zero pressure, and paid within 24 hours exactly like they promise.",
  },
];

const Testimonials = () => (
  <>
    <div className="mt-12 grid gap-6 md:grid-cols-2" data-testid="testimonials-grid">
      {quotes.map((q, i) => (
        <Reveal key={q.name} delay={i * 0.1}>
          <figure className="card-frame foil-sheen flex h-full flex-col p-7" data-testid={`testimonial-card-${i}`}>
            <div className="flex items-center justify-between">
              <div className="flex gap-1" aria-label="5 out of 5 stars">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} size={14} className="fill-gold text-gold" />
                ))}
              </div>
              <Quote size={20} className="text-mint/40" aria-hidden="true" />
            </div>
            <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-cream/80">“{q.text}”</blockquote>
            <figcaption className="mt-6 border-t border-cream/10 pt-4">
              <p className="font-serif text-base font-semibold text-cream">{q.name}</p>
              <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-mint">
                {q.city} · {q.tag}
              </p>
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
    <p className="mt-6 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-cream/40" data-testid="testimonials-sample-note">
      Sample stories shown as examples — real seller quotes arriving soon
    </p>
  </>
);

export default Testimonials;
